import React from "react";

const OfferConfirmation = ({ reference }) => (
  <div className="enquiry__message enquiry__message--success callout--flag callout--flag--green">
    <div className="flag">
      <div className="flag__img">
        <i className="fa fa-check-circle fa-fw fa-2x"></i>
      </div>
      <div className="flag__body">
        <div className="h2">Thanks for booking!</div>
        {reference &&
          <span>Your booking reference is <strong>{reference}</strong>. </span>
        }
        A confirmation email is on its way and you should receive it shortly.
      </div>
    </div>
  </div>
);

export default OfferConfirmation;



// WEBPACK FOOTER //
// ./components/last_minute_deals/LegacyOfferConfirmation.js